import {ref} from 'vue'
export  const rechargeHtml = ref('')